import { Injectable } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';
import { ApolloClient, ApolloClientOptions, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { environment } from '@env';
import { NgModule } from '@angular/core';
import { Apollo, ApolloModule as ApolloAngularModule } from 'apollo-angular';

@NgModule({
    imports: [ApolloAngularModule]
})
export class ApolloModuleService {
    constructor(private httpLink: HttpLink, private apollo: Apollo) {
        this.createApolloClient('etask', environment.GRAPHQL_URL, true);
    }

    createApolloClient(name: string, uri: string, isDefault: boolean) {
        const authLink = setContext((_, { headers }) => {
            const token = localStorage.getItem('userSecret');
            return {
                headers: {
                    ...headers,
                    Authorization: token ? `Bearer ${token}` : '',
                },
            };
        });

        if (isDefault)
            this.apollo.createDefault({
                link: authLink.concat(this.httpLink.create({ uri: uri })),
                cache: new InMemoryCache()
            });
        else
            this.apollo.createNamed(name, {
                link: authLink.concat(this.httpLink.create({ uri: uri })),
                cache: new InMemoryCache()
            });
    }
}